import { useEffect, useState } from "react";
import { api } from "../../api/client";
import { MONTHS } from "../../constants";
import {
  Button,
  DataCard,
  Empty,
  Icon,
  PageTitle,
  Select,
  Spinner,
  Td,
  Th
} from "../../components/ui";

function fmtDate(y, m, d) {
  const mn = MONTHS[(Number(m) || 1) - 1] || m;
  return `${d} ${mn} ${y}`;
}

function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-500/15 text-amber-600",
    approved: "bg-green-500/15 text-green-600",
    rejected: "bg-red-500/15 text-red-600"
  };
  return (
    <span className={`inline-flex rounded-full px-3 py-1 text-xs font-black capitalize ${map[status] || "bg-slate-100 text-slate-500"}`}>
      {status}
    </span>
  );
}

export default function EditRequestsPage({ user, setToast }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("pending");

  async function load() {
    setLoading(true);
    try {
      const res = await api.getEditRequests(filter);
      if (res.success) setRows(res.data || []);
      else setToast({ type: "error", message: res.message || "Gagal memuat" });
    } catch (err) {
      setToast({ type: "error", message: err.message });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, [filter]);

  async function review(item, status) {
    try {
      const res = await api.reviewEditRequest({
        id: item.id,
        status,
        type: item.type,
        reviewedBy: user.nickname || user.name
      });
      setToast({
        type: res.success ? "success" : "error",
        message: res.message || "Done"
      });
      if (res.success) load();
    } catch (err) {
      setToast({ type: "error", message: err.message });
    }
  }

  return (
    <>
      <PageTitle
        title="Permintaan Edit Absensi"
        subtitle="Setujui atau tolak permintaan trainer untuk mengedit absensi yang sudah terkunci. Persetujuan berlaku 24 jam."
        action={
          <Select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="w-40"
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
            <option value="all">Semua</option>
          </Select>
        }
      />

      {loading ? (
        <Spinner />
      ) : !rows.length ? (
        <Empty label="Tidak ada permintaan." />
      ) : (
        <DataCard>
          <table className="w-full min-w-[760px] whitespace-nowrap text-left">
            <thead>
              <tr>
                {["JENIS", "TRAINER", "TANGGAL", "SESSION", "DETAIL", "STATUS", "AKSI"].map((h) => (
                  <Th key={h} right={h === "AKSI"}>
                    {h}
                  </Th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={`${r.type}-${r.id}`}
                  className="border-t border-slate-200 dark:border-slate-800"
                >
                  <Td>
                    <span
                      className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-black ${
                        r.type === "addition"
                          ? "bg-purple-500/15 text-purple-600"
                          : r.type === "zero_completion"
                          ? "bg-amber-500/15 text-amber-600"
                          : "bg-blue-500/15 text-blue-600"
                      }`}
                    >
                      {r.type === "addition"
                        ? "Tambah Murid"
                        : r.type === "zero_completion"
                        ? "Tanpa Murid"
                        : "Edit Absensi"}
                    </span>
                  </Td>
                  <Td>
                    <p className="font-black">{r.trainer}</p>
                  </Td>
                  <Td>{fmtDate(r.year, r.month, r.day)}</Td>
                  <Td>{r.session}</Td>
                  <Td>
                    {r.type === "addition" ? (
                      <div>
                        <p className="font-bold">{r.studentName}</p>
                        <p className="text-xs text-slate-500">
                          dari {r.originTrainer || "-"}
                          {r.reason ? ` · ${r.reason}` : ""}
                        </p>
                      </div>
                    ) : (
                      <span className="text-slate-500">{r.reason || "-"}</span>
                    )}
                  </Td>
                  <Td>
                    <StatusBadge status={r.status} />
                  </Td>
                  <Td right>
                    {r.status === "pending" ? (
                      <div className="flex justify-end gap-2">
                        <Button variant="success" onClick={() => review(r, "approved")}>
                          <Icon name="check" />
                          Setujui
                        </Button>
                        <Button variant="danger" onClick={() => review(r, "rejected")}>
                          <Icon name="close" />
                          Tolak
                        </Button>
                      </div>
                    ) : (
                      <span className="text-xs text-slate-400">
                        {r.reviewedBy ? `oleh ${r.reviewedBy}` : "-"}
                      </span>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </DataCard>
      )}
    </>
  );
}
